import { css } from '@emotion/react'
import { Box, Typography } from '@mui/material'
import { HomepostsQuery } from 'generated/graphql'

import RelatedCard from '~/components/atoms/RelatedCard'

type Props = {
  related: HomepostsQuery
}

const BlogRelated: React.FC<Props> = ({ related }) => {
  const relatedPosts = () => {
    if (related.posts.length !== 0) {
      const posts = related.posts.map(post => (
        <li css={styles.listItem} className='f_card1' key={post.slug}>
          <RelatedCard
            url={post.slug}
            src={post.coverImage.url}
            title={post.title}
            excerpt={post.excerpt}
            date={post.date}
            category={post.category}
          />
        </li>
      ))
      return posts
    } else {
      return (
        <>
          <Typography variant='body1'>関連記事はありません</Typography>
        </>
      )
    }
  }
  return (
    <>
      <Box css={styles.container}>
        <Box css={styles.head}>
          <Typography variant='h1' css={styles.title} color='primary'>
            Related Articles
          </Typography>
          <Typography variant='h2' css={styles.subtitle} color='primary'>
            関連記事
          </Typography>
        </Box>
        <Box component='ul' css={styles.articleList}>
          {relatedPosts()}
        </Box>
      </Box>
    </>
  )
}

const styles = {
  container: css`
    padding-bottom: 100px;
  `,
  head: css`
    text-align: center;
    padding: 50px 0 30px;
    @media (min-width: 960px) {
      text-align: left;
      padding: 30px 0;
    }
  `,
  title: css`
    font-family: 'Montserrat', sans-serif;
    font-size: 2.5rem;
    font-weight: 700;
    margin: 40px 0 0;
    text-align: center;
    @media (min-width: 960px) {
      font-size: 4rem;
      text-align: left;
    }
  `,
  subtitle: css`
    line-height: 3rem;
    font-family: 'Noto Sans JP', sans-serif;
    font-size: 1rem;
    font-weight: 500;
    padding: 20px 40px 20px;
    @media (min-width: 960px) {
      padding: 0;
    }
  `,
  articleList: css`
    padding-inline-start: 0;
    padding: 0 5px;
  `,
  listItem: css`
    list-style: none;
    margin-bottom: 30px;
  `,
}

export default BlogRelated
